<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Project overview
                    </div>
                    <div class="card-block">
                        <ProjectCategoryFilter v-model="categoryFilter"></ProjectCategoryFilter>
                    </div>
                    <div class="card-block">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <label class="col-form-label">Period from (v1)</label>
                                <div class="col-md-3">
                                    <datepicker placeholder="yyyy-mm-dd" input-class="projects-overview-date-picker" :disabled-dates="{from: new Date(periodTo)}" v-model="periodFrom" format="yyyy-MM-dd"></datepicker>
                                </div>
                                <label class="col-form-label">Period to (v2)</label>
                                <div class="col-md-3">
                                    <datepicker placeholder="yyyy-mm-dd" input-class="projects-overview-date-picker" :disabled="!periodFrom" :disabled-dates="{to: new Date(periodFrom)}" v-model="periodTo" format="yyyy-MM-dd"></datepicker>
                                </div>
                                <div class="col-md-3">
                                  <b-dropdown id="dropdown-1" :text="selectedProjectLead.displayName" class="">
                                    <b-dropdown-item v-for="lead in projectLeads" :key="lead.project_lead_id"
                                      :active="lead.project_lead_id===selectedProjectLead.project_lead_id"
                                      @click="selectProjectLead(lead)">
                                      {{lead.displayName}}
                                    </b-dropdown-item>
                                  </b-dropdown>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-bordered table-striped table-condensed">
                                    <thead>
                                        <tr class="tr-full-width">
                                            <th style="background-color: #2ca02c;" colspan="4">Contractual</th>
                                            <th style="background-color: #ebcccc;" colspan="6">Actual</th>
                                            <th style="background-color: dodgerblue;" colspan="3">Estimated at completion</th>
                                        </tr>
                                        <tr class="tr-full-width">
                                            <th>Project</th>
                                            <th>Revenue</th>
                                            <th>Cost</th>
                                            <th>Profit</th>
                                            <th>Revenue<br> per period</th>
                                            <th colspan="2">Cost per period <br>
                                                <div class="row no-padding">
                                                    <div class="col-md-6 labour-heading-cell">Labour</div>
                                                    <div class="col-md-6 material-heading-cell">Material</div>
                                                </div>
                                            </th>
                                            <th>Profit per period</th>
                                            <th>POC2</th>
                                            <th>ETC2</th>
                                            <th>Cost</th>
                                            <th>Profit</th>
                                            <th>Variance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <ProjectOverviewRow v-if="showProject(project.id)" v-for="project in projectsArray" :key="project.id" :periodFrom="periodFrom" :periodTo="periodTo" :projectId="project.id"></ProjectOverviewRow>
                                    <ProjectOverviewSumRow :selectedProjectLead="selectedProjectLead" :categoryFilter="categoryFilter" :periodTo="periodTo"></ProjectOverviewSumRow>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!--/.col-->
        </div><!--/.row-->
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import Vue from 'vue';
import ProjectOverviewRow from './ProjectOverviewRow.vue';
import ProjectOverviewSumRow from './ProjectOverviewSumRow.vue';
import ProjectCategoryFilter from './ProjectCategoryFilter.vue';

export default {
  name: 'ProjectsOverview',
  components: {
    ProjectOverviewRow,
    ProjectOverviewSumRow,
    ProjectCategoryFilter,
    Datepicker
  },
  data: function () {
    return {
      periodTo: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
      periodFrom: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      categoryFilter: {},
      selectedProjectLead: {
        project_lead_id: '',
        displayName: 'Project leads'
      },
      projectsArray: []
    };
  },
  watch: {
    projects: function () {
      const projects = JSON.parse(JSON.stringify(this.projects));
      this.projectsArray = Object.values(projects).sort((a, b) => { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0); });
    },
    periodTo: function () {
      this.setFilters();
      this.GET_PROJECTS_OVERVIEWS({ periodFrom: moment(this.periodFrom).format('YYYY-MM-DD'), periodTo: moment(this.periodTo).format('YYYY-MM-DD') });
    },
    periodFrom: function () {
      this.setFilters();
      this.GET_PROJECTS_OVERVIEWS({ periodFrom: moment(this.periodFrom).format('YYYY-MM-DD'), periodTo: moment(this.periodTo).format('YYYY-MM-DD') });
    }
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects', 'projectCategories', 'projectLeads']),
    ...mapGetters('Filters', ['filters'])
  },
  methods: {
    ...mapActions('ProjectsOverview', ['GET_PROJECTS_OVERVIEWS']),
    ...mapActions('JiraProjects', ['LOAD_JIRA_PROJECTS']),
    //            loadProjectsOverviewData(){
    //                this.GET_PROJECTS_OVERVIEWS({periodFrom: this.periodFrom, periodTo: this.periodTo});
    //            },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    setAllCategoriesActive() {
      for (const categoryId in this.projectCategories) {
        Vue.set(this.categoryFilter, categoryId, true);
      }
      Vue.set(this.categoryFilter, 'active', true);
      Vue.set(this.categoryFilter, null, true);
      this.setFilters();
    },
    showProject(projectId) {
      const active = (
        this.projects[projectId].end_date >= moment(this.periodTo).format('YYYY-MM-DD')
                  || this.projects[projectId].change_requests_end_date >= moment(this.periodTo).format('YYYY-MM-DD')
      );
      if (this.selectedProjectLead.project_lead_id) {
        if (!this.categoryFilter['active']) {
          if ((
            this.projects[projectId].end_date
              && this.projects[projectId].end_date >= '2018-01-01'
              && this.projects[projectId].end_date < moment().format('YYYY-MM-DD')
          ) || (
            this.projects[projectId].change_requests_end_date
              && this.projects[projectId].change_requests_end_date >= '2018-01-01'
              && this.projects[projectId].change_requests_end_date < moment().format('YYYY-MM-DD')
          )) {
            return this.categoryFilter[this.projects[projectId].category_id] && this.projects[projectId].project_lead_id == this.selectedProjectLead.project_lead_id;
          }
        } else {
          return active && this.categoryFilter[this.projects[projectId].category_id] && this.projects[projectId].project_lead_id == this.selectedProjectLead.project_lead_id;
        }
        return false;
        //                    return (!this.categoryFilter['active'] || active) && this.categoryFilter[this.projects[projectId].category_id] && this.projects[projectId].project_lead_id == this.selectedProjectLead.project_lead_id;
      }
      if (!this.categoryFilter['active']) {
        if (
          (
            this.projects[projectId].end_date
                        && this.projects[projectId].end_date >= '2018-01-01'
                        && this.projects[projectId].end_date < moment().format('YYYY-MM-DD')
          )
                      || (
                        this.projects[projectId].change_requests_end_date
                        && this.projects[projectId].change_requests_end_date >= '2018-01-01'
                        && this.projects[projectId].change_requests_end_date < moment().format('YYYY-MM-DD'))
        ) {
          return this.categoryFilter[this.projects[projectId].category_id];
        }
      } else {
        return active && this.categoryFilter[this.projects[projectId].category_id];
      }
      //                return (!this.categoryFilter['active'] || active) && this.categoryFilter[this.projects[projectId].category_id];
    },
    selectProjectLead(lead) {
      this.selectedProjectLead = lead;
      this.setFilters();
    },
    setFilters() {
      this.$store.state.Filters.filters.routeName = 'ProjectsOverview';
      this.$store.state.Filters.filters.parameters = {
        periodTo: moment(this.periodTo).format('YYYY-MM-DD'),
        periodFrom: moment(this.periodFrom).format('YYYY-MM-DD'),
        categories: this.categoryFilter,
        projectLead: this.selectedProjectLead
      };
    },
    loadFilters() {
      this.categoryFilter = this.filters.parameters.categories;
      this.selectedProjectLead = this.filters.parameters.projectLead;
      this.periodFrom = this.filters.parameters.periodFrom;
      this.periodTo = this.filters.parameters.periodTo;
    }
  },
  created() {
  },
  mounted() {
    this.LOAD_JIRA_PROJECTS();
    this.GET_PROJECTS_OVERVIEWS({ periodFrom: this.periodFrom, periodTo: this.periodTo });
    //            this.setAllCategoriesActive();
    if (this.filters.routeName == 'ProjectsOverview') {
      this.loadFilters();
    } else {
      this.setAllCategoriesActive();
    }
  },
};
</script>

<style lang="scss" scoped>
    .project-leads-dropdown {
        padding-top: 10px;
    }
    .table {
        height: 700px;
    }
    .no-padding {
        padding: 0px;
        margin: 0px;
    }
    .labour-heading-cell {
        padding: 0px;
        border-top: 1px solid black;
        border-right: 1px solid black;
    }
    .material-heading-cell {
        padding: 0px;
        border-top: 1px solid black;
    }
    tbody{
        overflow-y: scroll;
        max-height: 630px;
        position: absolute;
    }

    thead .tr-full-width {
        width: 100%;
        display: inline-table;
        /*height:100px;*/
        table-layout: fixed;
    }
    tbody tr {
        width: 100%;
        display: inline-table;
        table-layout: fixed;

    }
    .currency::before{
        content: "€";
    }
    .percentage::after{
        content: "%";
    }
    thead > tr {
        th {
            border: 1px solid black;
        }
        td {
            border: 1px solid black;
        }
    }
    th {
        text-align: center;
        padding: 0;
    }
    thead > tr > td {
        text-align: center;
    }
    tbody > tr:hover {
        background-color: #c8d2d2;
    }

    .dg-btn--ok {
        color: #fff;
        background-color: #20a8d8;
        border-color: #20a8d8;
        border-radius: var(--border-radius);
        line-height: inherit;
    }

    .dg-btn--ok:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #1985ac;
        border-color: #187fa3;

    }
</style>
<style>
    .projects-overview-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.5rem 0.75rem;
    }
</style>
